import { PbPatchReturnProcessConditionsReq } from '@itsrever/rever-api'
import { patchReturnConditions } from '@/api/settings-api'
import { useEcommerceId } from '@/hooks/use-ecommerce-id'
import {
  useSettingsDraft,
  useSettingsMutation
} from '@/application/manage-settings'
import {
  ReturnConditionsSettings,
  emptyReturnConditions,
  hasAttributesToPatch,
  invalidReturnConditionsFields,
  toPatchRequest,
  toReturnConditions
} from './return-conditions'
import {
  returnConditionsKey,
  useStoredReturnConditions
} from './stored-return-conditions'

export function useReturnConditions() {
  const { stored, loading, loadFailed, reload } =
    useStoredReturnConditions(toReturnConditions)
  const [returnConditions, setReturnConditions] = useSettingsDraft(
    stored,
    emptyReturnConditions
  )

  return {
    returnConditions,
    setReturnConditions,
    originalReturnConditions: stored ?? emptyReturnConditions,
    loadingReturnConditions: loading,
    returnConditionsFailed: loadFailed,
    reloadReturnConditions: reload
  }
}

export function useSaveReturnConditions() {
  const ecommerceId = useEcommerceId()
  const { save, saving } = useSettingsMutation({
    mutationFn: (request: PbPatchReturnProcessConditionsReq) =>
      patchReturnConditions(request),
    invalidate: returnConditionsKey(ecommerceId),
    successKey: 'return_conditions.save_success',
    errorKey: 'return_conditions.save_error'
  })

  async function callSaveReturnConditions(
    original: ReturnConditionsSettings,
    edited: ReturnConditionsSettings
  ) {
    if (!ecommerceId) return false
    if (invalidReturnConditionsFields(original, edited).length > 0) return false

    const request = toPatchRequest(ecommerceId, original, edited)
    if (!hasAttributesToPatch(request)) return false

    return save(request)
  }

  return { callSaveReturnConditions, loadingSaveReturnConditions: saving }
}
